import {Swiper} from "swiper";
import {FreeMode, Navigation} from "swiper/modules";
let swiperInstance;

const clearSwiper = () => {
  if (swiperInstance) {
    swiperInstance.destroy(true, true); // Destroy Swiper instance
    swiperInstance = null; // Set swiper to null
    $(`.js-square-blocks-with-images-swiper .square-blocks`).removeAttr('style');

  }
}
window.initBlocksSwiper = (selector = '.js-square-blocks-with-images-swiper') => {
  if ($(selector).length === 0) {
    return false;
  }
  clearSwiper();

  $(selector).each(function () {
    if ($(this).hasClass('swiper-container-initialized')) {
      return false;
    }
    let parentElement = $(this).parent().parent();
    let swiperNavPrev = parentElement.find('.swiper-nav-prev')[0];
    let swiperNavNext = parentElement.find('.swiper-nav-next')[0];
    swiperInstance = new Swiper($(this)[0], {
      modules: [FreeMode, Navigation],
      breakpoints: {
        320: {
          slidesPerView: 'auto',
          freeMode: true, // Enable free mode for smooth scrolling
          spaceBetween: 8
        },
        992: {
          enabled: false
        }
      },
      loop: true,
      navigation: {
        nextEl: swiperNavNext,
        prevEl: swiperNavPrev,
      },
    });
  });
}

function toggleSwiper(swiperInstance) {
  if (window.innerWidth >= 1025) {
    clearSwiper();
  } else {
    initBlocksSwiper();
  }
}

$(document).ready(() => {
  initBlocksSwiper();
  let selector = $('.js-square-blocks-with-images-swiper');
  if (selector.length !== 0) {
    window.addEventListener('resize', () => toggleSwiper(selector));
  }
})
